import { snapshot } from 'valtio';
import { PolicySettingCategory, PolicySetting } from '../policy-settings-types';
import PolicySettingsStore from './policy-settings-store';

export const setPolicySettings = (policySettings: PolicySettingCategory[]) => {
  PolicySettingsStore.policySettings = policySettings;
};

export const setPolicySetting = (
  policyId: string,
  categoryId: string,
  newValue: PolicySetting,
) => {
  const { policySettings } = snapshot(PolicySettingsStore);
  const newPolicySettings = policySettings.map(category =>
    category.categoryId === categoryId
      ? {
          ...category,
          settings: category.settings.map(policy =>
            policy.policyId === policyId ? newValue : policy,
          ),
        }
      : category,
  );
  PolicySettingsStore.policySettings = newPolicySettings;
};

export const setPolicySettingsLoading = (value: boolean) => {
  PolicySettingsStore.isLoading = value;
};
